import React, { useEffect } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NoData from "assets/images/UI/no_data.svg";
import StaplesReportsBreadcrumb from "./StaplesReportsBreadcrumb";
import { isStaplesOrg } from "utilities/organizationUtils";

const StaplesReports = () => {
  const navigate = useNavigate();
  const organizationId = useSelector((state) => state.auth?.organization_id);

  useEffect(() => {
    if (organizationId && !isStaplesOrg(organizationId)) {
      navigate("/leader/audit/new-analytics", { replace: true });
    }
  }, [organizationId, navigate]);

  return (
    <PageWrapper>
      {/* <StaplesReportsBreadcrumb /> */}
      <EmptyWrapper>
        <EmptyContent>
          <EmptyIcon>
            <img src={NoData} alt="No reports available" style={{ width: 200 }} />
          </EmptyIcon>
          <EmptyTitle>No Reports Available</EmptyTitle>
                  {/* <EmptySubtitle>
            No reports found. Please check your report data or try refreshing.
          </EmptySubtitle> */}
        </EmptyContent>
      </EmptyWrapper>
    </PageWrapper>
  );
};

export default StaplesReports;

const PageWrapper = styled.div`
  padding: 24px;
  background: #ffffff;
  min-height: 100vh;
  width: 100%;
`;

const EmptyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100vh - 120px);
  width: 100%;
`;

const EmptyContent = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

const EmptyIcon = styled.div`
  margin-bottom: 16px;
  display: flex;
  justify-content: center;
`;

const EmptyTitle = styled.h2`
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  font-weight: 700;
  font-size: 22px;
  color: #111827;
  margin: 0 0 8px 0;
`;

const EmptySubtitle = styled.p`
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
    sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #6b7280;
  margin: 0;
`;

